import {
  HANDLE_PROJECTS,
  SET_TEMPLATE,
  HANDLE_SOURCE_DATA,
  HANDLE_CARD_INFO,
  RESET_STORE,
  HANDLE_EDIT_MODE,
  HANDLE_REPORT_KEY,
  HANDLE_TEMPLATE_ID,
  HANDLE_TRIGGER_INFO,
  HANDLE_SLACK_DATA,
  HANDLE_REPORT_ACCESS_DATA,
  HANDLE_CARD_TEMPLATE_ID,
  HANDLE_ISSUE_CARD_INFO,
  HANDLE_APPEARANCE_INFO,
  HANDLE_SORTLIST_DATA,
  HANDLE_ISSUE_API_DATA,
  HANDLE_REPORT_OPTIONS,
  SET_INITIAL_SORTLIST_DATA,
  HANDLE_SEND_NOTIFICATION,
} from './types';

const initialState = {
  selectedProjects: [],
  //   filter: {},
  template: {}, // troopr workspace unique id to find a workspace
  card_template_id: {}, // report template id used to create this report
  key: '', // all the reports will have a key based on key we will generate reports  Key example: jira_burn_down_chart, get_issues_by_jql,jira_velocity_char
  //   cardInformation: {},

  triggerInformation: null, // information about when to run this report
  slackData: null, // channel and users info to deliver this report , custom message shown to user in slack.
  //   name: '', // report name
  //   type: {},
  //   scope: {}, //
  //   desc: String, // report description
  //   is_enabled: true, //  report enabled or disabled
  //   skill_type: 'app_message', // if skill_type is app_home then it is apphome report
  //   app: '',
  cardInfo: {},
  isEditMode: false,
  sourceData: {}, //  Jira, Github, Troopr,
  issueCardInfo: {},
  appearanceData: [],
  isLoading: false,
  sortlistData: {},
  initialSortListData: {},
  issueApiData: {},
  reportOptions: {},
  reportColors: [],
  sendNotificationMessage: true,
};

export default (state = initialState, action = {}) => {
  // console.log("STATE",action)
  switch (action.type) {
    // case HANDLE_PROJECTS:
    //   return {
    //     ...state,
    //     selectedProjects: action.selectedProjectsForReport,
    //   };
    case SET_TEMPLATE:
      return {
        ...state,
        template: action.template,
      };
    case HANDLE_CARD_INFO:
      return {
        ...state,
        cardInfo: action.cardInfo,
      };

    case HANDLE_CARD_TEMPLATE_ID:
      return {
        ...state,
        card_template_id: action.data,
      };
    // case HANDLE_SOURCE_DATA:
    //   return {
    //     ...state,
    //     sourceData: {
    //       ...state.sourceData,
    //       [action.sourceData.key]:
    //         Array.isArray(action.sourceData.value) ||
    //         typeof action.sourceData.value == 'string'
    //           ? action.sourceData.value
    //           : {
    //               ...state.sourceData[action.sourceData.key],
    //               ...action.sourceData.value,
    //             },
    //       ...action.sourceData.data,
    //     },
    //   };
    case RESET_STORE:
      return { ...initialState };
    case HANDLE_EDIT_MODE:
      return { ...state, isEditMode: action.mode };

    case HANDLE_REPORT_KEY:
      return { ...state, key: action.key };

    case HANDLE_TEMPLATE_ID:
      return { ...state, card_template_id: action.template_id };

    case HANDLE_TRIGGER_INFO:
      return { ...state, triggerInformation: action.data };

    case HANDLE_SLACK_DATA:
      return { ...state, slackData: action.data };

    case HANDLE_REPORT_ACCESS_DATA:
      return { ...state, reportAccessMembers: action.data };

    case HANDLE_ISSUE_CARD_INFO:
      return { ...state, issueCardInfo: action.data };
    case HANDLE_APPEARANCE_INFO:
      return { ...state, appearanceData: action.appearanceData };
    case 'SET_REPORT_COLORS':
      return { ...state, reportColors: action.reportColors };

    case HANDLE_SORTLIST_DATA:
      return { ...state, sortListData: action.sortListData };
    case SET_INITIAL_SORTLIST_DATA:
      return { ...state, initialSortListData: action.initialSortListData };
    case HANDLE_ISSUE_API_DATA:
      return {
        ...state,
        issueApiData: action.issueApiData,
      };
    case HANDLE_REPORT_OPTIONS:
      return {
        ...state,
        reportOptions: action.reportOptions,
      };
    case HANDLE_SEND_NOTIFICATION:
      return { ...state, sendNotificationMessage: action.data };

    default:
      return state;
  }
};
